if (typeof CarouselHandler === 'undefined') {
  class CarouselHandler {
    constructor() {
      this.init();
    }

    init() {
      // Handle initial load after a delay
      setTimeout(() => {
        this.equalizeCarouselHeights();
      }, 500);

      // Handle Shopify section loads
      document.addEventListener("shopify:section:load", () => {
        this.equalizeCarouselHeights();
      });

      // if we have swatches in a section, equalize the slide heights after swatch input change events
      const swatchInputs = document.querySelectorAll("input[data-swatch-input]");
      swatchInputs.forEach((input) => {
        input.addEventListener("change", () => {
          this.equalizeCarouselHeights();
        });
      });

      // Handle window resize
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.equalizeCarouselHeights();
        }, 250);
      });
    }

    reinitializeOkendoReviews(carousel) {
      // Find all Okendo review containers in cloned slides
      const clonedSlides = carousel.querySelectorAll('.slick-cloned [data-oke-star-rating]');
      clonedSlides.forEach(reviewContainer => {
        const originalId = reviewContainer.getAttribute('data-oke-reviews-product-id');
        if (originalId) {
          // Find the original slide's review HTML
          const originalReview = carousel.querySelector(`.slick-slide:not(.slick-cloned) [data-oke-reviews-product-id="${originalId}"]`);
          if (originalReview) {
            // clone the original review and replace the cloned review with the original review
            const originalReviewClone = originalReview.cloneNode(true);
            reviewContainer.replaceWith(originalReviewClone);
          }
        }
      });
    }

    equalizeCarouselHeights() {
      const carousels = document.querySelectorAll("[data-slick]");

      carousels.forEach((carousel) => {
        // Get all cells in this carousel
        const cells = carousel.querySelectorAll(".slick-slide");
        let maxHeight = 0;

        // Reset heights first
        cells.forEach((cell) => {
          cell.style.height = "auto";
        });

        // Find the tallest cell
        cells.forEach((cell) => {
          const height = cell.offsetHeight + 1;
          maxHeight = height > maxHeight ? height : maxHeight;
        });

        // Set all cells to the maximum height
        cells.forEach((cell) => {
          cell.style.height = `${maxHeight}px`;
        });

        carousel.style.height = `${maxHeight}px`;

        // Reinitialize Okendo reviews in cloned slides
        this.reinitializeOkendoReviews(carousel);

        // Add scroll event handling
        carousel.addEventListener(
          "wheel",
          function (e) {
            if (window.innerWidth >= 750) {
              // Only handle horizontal scrolling when the horizontal component is larger
              // This helps distinguish between vertical and horizontal trackpad gestures
              if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
                e.preventDefault();

                // Determine scroll direction
                const delta = Math.sign(e.deltaX);

                if (delta > 0) {
                  $(this).slick("slickNext");
                } else {
                  $(this).slick("slickPrev");
                }
              }
            }
          }, { passive: false }
        );
      });
    }
  }
  // Initialize the handler
  document.addEventListener("DOMContentLoaded", () => {
    new CarouselHandler();
  });

  // also update on shopify section load
  document.addEventListener("shopify:section:load", () => {
    new CarouselHandler();
  });
}
